import request from '../config/axiosConfig';
import { LOGIN, LOGOUT, CHANGE_PASSWORD } from '../constants/apiEndPoint';

export const loginRequest = async (data) => {
  return (await request({
    url: LOGIN,
    method: 'POST',
    data,
  }))?.data;
};

export const logoutRequest = async (data) => {
  data = {};
  data['return-sample'] = 1;
  data['data-sample'] = {
    "code": 200,
    "isSuccess": true,
    "status": 1,
    "message": "Thành công!",
    "debugMessage": "Thành công!",
    "data": null
  };
  return (await request({
    url: LOGOUT,
    method: 'POST',
    data,
  }))?.data;
};

export const changePassword = async ({ old_password, new_password }) => {
  return (
    await request({
      url: CHANGE_PASSWORD,
      method: 'POST',
      data: { old_password, new_password },
    })
  )?.data;
};
